import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from "@apollo/client";
import { Loader } from 'semantic-ui-react';
import { areIntervalsOverlappingWithOptions } from 'date-fns/fp';

// Function to dynamically load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById("razorpay-script");
    if (existingScript) {
      return resolve(true); // If the script is already present, resolve immediately.
    }

    const script = document.createElement("script");
    script.id = "razorpay-script";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true); // Resolve when the script is successfully loaded
    script.onerror = (err) => reject(new Error("Failed to load Razorpay SDK: " + err.message)); // Reject if script fails to load
    document.body.appendChild(script);
  });
};

const ORDER_BY_CART = gql`
mutation OrderbyCart($couponId: Int, $userId: Int, $shopId: Int, $voucherNo: String, $orderType: String, $customerId: Int, $customerName: String, $customerMobile: String, $customerAddress: String, $pickuptime: DateTime, $feedback: String, $shopPhone: String, $rating: Int, $billingAddress: Int, $shippingAddress: Int, $paymentInfo: String, $creditPoints: Float) {
  OrderbyCart(couponId: $couponId, userId: $userId, shopId: $shopId, voucherNo: $voucherNo, orderType: $orderType, customerId: $customerId, customerName: $customerName, customerMobile: $customerMobile, customerAddress: $customerAddress, pickuptime: $pickuptime, feedback: $feedback, shopPhone: $shopPhone, rating: $rating, billingAddress: $billingAddress, shippingAddress: $shippingAddress, paymentInfo: $paymentInfo, creditPoints: $creditPoints) {
    id
    shopId
    orderType
    customerId
    customerName
    customerMobile
    customerAddress
    customerGstin
    userOrder
    pickuptime
    rating
    feedback
    paymentInfo
    billingAddress
    shippingAddress
  }
}
`

const RazorpayPayment = ({ shopDetails, address, addressId, cart, deliveryCharge, billingAddress }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [orderProduct, { loading: orderProductLoading, error: orderProductError }] = useMutation(ORDER_BY_CART);

  // Function to handle the payment
  const handlePayment = async () => {
    setIsLoading(true);
    let razorpayKey = shopDetails[0]["razorpay_key"];
    if (!razorpayKey) {
      placeOrder("Cash On Delivery", null);
      return;
    }
    if (deliveryCharge == "Free") {
      deliveryCharge = 0;
    }
    else {
      deliveryCharge = Number(deliveryCharge);
    }
    let totalAmount = 0;
    cart.map((c) => {
      let prize = convertIntoNumber(c.prize);
      let tax = convertIntoNumber(c.tax);
      prize = prize + ((prize * tax)/100);
      totalAmount =totalAmount + prize;
    })
    totalAmount = totalAmount + deliveryCharge;
    totalAmount = totalAmount.toFixed(0);
    let customerMobile = "";
    let customerName = "";
    address.map((c) => {
      if (c.id == addressId) {
        customerMobile = c.phone;
        customerName = c.name;
      }
    })
    let shopname = shopDetails[0]["shop_name"];
    let razorpaySecretKey = shopDetails[0]["razorpay_secret_key"];
    try {
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        setIsLoading(false);
        alert("Failed to load Razorpay SDK.");
        return;
      }
      const options = {
        key: razorpayKey, // Replace with your Razorpay key
        amount: totalAmount * 100, // Amount in paise (smallest currency unit)
        currency: "INR",
        name: shopname,
        description: "Order Payment",
        handler: function (response) {
          placeOrder("Online Payment", response.razorpay_payment_id);
        },
        prefill: {
          name: customerName,
          contact: customerMobile,
        },
        theme: {
          color: "#3399cc",
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (err) {
      setIsLoading(false);
      alert(`Error: ${err.message}`);
      console.error(err);
    }
  };

  const convertIntoFloat = (value) => {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  } 

  const convertIntoNumber = (value) => {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  const placeOrder = (orderType, paymentId) => {
    let today = new Date();
    let pickupDate = today.toISOString().split('T')[0];
    if (!paymentId) {
      paymentId = "";
    }
    if (deliveryCharge == "Free") {
      deliveryCharge = 0;
    }
    else {
      deliveryCharge = Number(deliveryCharge);
    }
    let totalAmount = 0;
    let userId = 0;
    cart.map((c) => {
      let prize = convertIntoNumber(c.prize);
      let tax = convertIntoNumber(c.tax);
      prize = prize + ((prize * tax)/100);
      totalAmount =totalAmount + prize;
      userId = c.user_id;
    })
    totalAmount = totalAmount + deliveryCharge;
    let addressLine = "";
    let customerMobile = "";
    let customerName = "";
    address.map((c) => {
      if (c.id == addressId) {
        addressLine = c.street+", "+c.city+", "+c.state+", "+c.country+"-"+c.pincode;
        customerMobile = c.phone;
        customerName = c.name;
      }
    })
    let shopNumber = shopDetails[0]["phone"];
    let shopId = shopDetails[0]["id"];
    shopId = convertIntoNumber(shopId);
    try {
      orderProduct({
        variables: {
          "userId": convertIntoNumber(userId),
          "shopId": shopId,
          "voucherNo": "1",
          "orderType": orderType,
          "customerId": 1,
          "customerName": customerName,
          "customerMobile": customerMobile,
          "customerAddress": addressLine,
          "pickuptime": pickupDate,
          "feedback": "",
          "creditAmount": totalAmount,
          "rating": 5,
          "shopPhone": shopNumber,
          "couponId": 0, 
          "paymentInfo": paymentId,
          "billingAddress": convertIntoNumber(billingAddress),
          "shippingAddress": convertIntoNumber(addressId),
          "creditPoints": 0,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.OrderbyCart.length == 0) {
            alert("Order Failed!!! Please Try Again Later");
            return;
          }  
          setIsLoading(false);
          alert("Order Placed Successfully!!!!")
          window.location.href = "https://test.shop.strackit.com"
        })
        .catch((mutationError) => {
          setIsLoading(false);
          console.error('Mutation error:', mutationError);
        });
    } catch (err) {
      setIsLoading(false);
      alert(err)
    }
  }

  return (
    <div>
      <button
        onClick={handlePayment}
        className="checkout-button"
        disabled={isLoading}
        style={{ padding: "13px", backgroundColor: "green", color: "white", cursor: "pointer", width: "200px", marginRight: "15px" }}
      >
        {isLoading ? "Processing..." : shopDetails[0]["razorpay_key"] ? "Pay Now" : "Cash On Delivery"}
      </button>
      {/* <button
        onClick={handlePayment}
        className="checkout-button"
        disabled={isLoading}
        style={{ padding: "13px", backgroundColor: "#2596be", color: "white", cursor: "pointer", width: "200px" }}
      >
        {isLoading ? "Processing..." : "Cash On Delivery"}
      </button> */}
    </div>
  );
};

export default RazorpayPayment;
